import axios from "axios";
import $ from "jquery";

var general = {
    init: function() {
        // Scroller links
        let $scrollerLinks = document.querySelectorAll(".js-scroller");
        if ($scrollerLinks.length > 0) {
            this.scrollerLinks($scrollerLinks);
        }

        // Js submitted forms
        let $jsSubmittedForms = document.querySelectorAll("form.js-submit");
        if ($jsSubmittedForms.length > 0) {
            this.jsSubmittedForms($jsSubmittedForms);
        }

        // Back links
        let $backLinks = document.querySelectorAll(".js-back");
        if ($backLinks.length > 0) {
            this.backLinks($backLinks);
        }

        // Print links
        let $printLinks = document.querySelectorAll(".js-print");
        if ($printLinks.length > 0) {
            this.printLinks($printLinks);
        }

        // Modal links
        let $modalLinks = document.querySelectorAll(".js-fire-modal");
        if ($modalLinks.length > 0) {
            this.modalLinks($modalLinks);
        }

        // Password fields
        let $passwordFields = document.querySelectorAll(".js-password-field");
        if ($passwordFields.length > 0) {
            this.togglePassword($passwordFields);
        }

        this.productText();
        this.uiToTop();
    },

    scrollerLinks: function($scrollerLinks) {
        $scrollerLinks.forEach(($scrollerLink) => {
            $scrollerLink.addEventListener("click", function(e) {
                let id = $scrollerLink.getAttribute("data-scroller");
                let target = document.getElementById(id);
                const yOffset = -100;

                if (target !== null) {
                    e.preventDefault();
                    const y =
                        target.getBoundingClientRect().top +
                        window.pageYOffset +
                        yOffset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            });
        });
    },

    jsSubmittedForms: function($jsSubmittedForms) {
        $jsSubmittedForms.forEach((form) => {
            form.addEventListener("submit", (event) => {
                event.preventDefault();
                let data = new FormData(form);
                axios
                    .post(form.action, data)
                    .then((response) => {
                        window.location.href = response.data.url || "?";
                    })
                    .catch((error) => alert("An error occured. Sorry.")); // todo!!
            });
        });
    },

    backLinks: function($backLinks) {
        $backLinks.forEach((link) => {
            if (document.referrer.indexOf("/products") !== -1) {
                link.addEventListener("click", (e) => {
                    window.history.back();
                    e.preventDefault();
                });
            }
        });
    },

    printLinks: function($backLinks) {
        $backLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                window.print();
                e.preventDefault();
            });
        });
    },

    modalLinks: function($modalLinks) {
        $modalLinks.forEach((link) => {
            link.addEventListener("click", (e) => {
                let id = link.getAttribute("data-target");
                $(id).modal();
                e.stopPropagation();
                e.preventDefault();
            });
        });
    },

    togglePassword: function($passwordFields) {
        $passwordFields.forEach((field) => {
            var inputGroup = field.closest(".input-group");
            var showPasswordButton = inputGroup.querySelector(
                ".js-show-password"
            );
            var hidePasswordButton = inputGroup.querySelector(
                ".js-hide-password"
            );
            if (showPasswordButton && hidePasswordButton) {
                showPasswordButton.addEventListener("click", function(e) {
                    toggle(
                        field,
                        "text",
                        showPasswordButton,
                        hidePasswordButton
                    );
                });
                hidePasswordButton.addEventListener("click", function(e) {
                    toggle(
                        field,
                        "password",
                        showPasswordButton,
                        hidePasswordButton
                    );
                });
            }
        });

        function toggle(field, type, showButton, hideButton) {
            field.setAttribute("type", type);
            showButton.classList.toggle("d-none");
            hideButton.classList.toggle("d-none");
        }
    },

    uiToTop: function() {
        var showUiToTop = $("#show-ui-to-top").val() !== "no";
        if (showUiToTop) {
            $().UItoTop({ easingType: "linear" });

            var toTop = $("#toTop");
            var $w = $(window);

            $w.on("DOMContentLoaded load resize scroll", function() {
                if ($w.scrollTop() + $w.height() > $(document).height() - 150) {
                    toTop.addClass("near-bottom");
                } else {
                    toTop.removeClass("near-bottom");
                }
            });
        }
    },

    productText: function() {
        var $productText = $(".product__text");
        if ($productText.length > 0) {
            var _y = $productText.offset().top - 150;
            if ($productText.height() > 320) {
                $productText.removeClass("product__text--expanded");
            } else {
                $productText.addClass("product__text--expanded mb-5");
                $(".product__text-btn").addClass("d-none");
            }
            $(".product__text-btn").on("click", function(e) {
                e.preventDefault();
                $(".product__text-btn").toggleClass("d-none");
                $productText.toggleClass("product__text--expanded");

                if (!$productText.hasClass("product__text--expanded")) {
                    window.scrollTo({
                        top: _y,
                        behavior: "smooth",
                    });
                }
            });
        }
    },
};

export default general;
